import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

import "../Footer.scss";
import classNames from "classnames";
import { isRTL } from "../../../../../constants";

const FooterLinks = ({ heading, linkItem, columnNum }) => {
  return (
    // <Card.Body>
    //   {heading && (
    //     <Card.Title as="h4" className="footer-heading">
    //       {t(heading)}
    //     </Card.Title>
    //   )}
    //   <Row className="footer-link-wrapper">
    <>
      {linkItem.map(
        (item, key) =>
          // <Col sm={columnNum} className="footer-link-item" key={key}>
          item?.linkType === "custom" ? (
            <a
              key={key}
              href={item?.customUrl}
              target={item?.urlTarget}
              className={classNames("footer-link", isRTL ? "me-3" : "ms-3")}>
              {item?.title}
            </a>
          ) : (
            <Link
              key={key}
              to={"/content-page/" + item?.contentPage?.slug}
              target={item?.urlTarget}
              className={classNames("footer-link", isRTL ? "me-3" : "ms-3")}>
              {item?.title}
            </Link>
          )
        // </Col>
      )}
    </>
    //   </Row>
    // </Card.Body>
  );
};

FooterLinks.propTypes = {
  heading: PropTypes.string,
  linkItem: PropTypes.array,
  columnNum: PropTypes.string,
};
export default FooterLinks;
